
import {EventBus} from "src/eventBus";

export default
{
    jsPlumb: null,
    isReadonly: false,
    store: null,

    setJSPlumb(jsPlumb, readonly, store) {
        this.jsPlumb = jsPlumb;
        this.isReadonly = readonly;
        this.store = store;
    },
    
    reset() {
        if(this.jsPlumb) {
            this.jsPlumb.unbind("beforeDrop");
            this.jsPlumb.unbind("connection");
            this.jsPlumb.unbind("connectionDetached");
            this.jsPlumb.reset();
            this.jsPlumb = null;
        }
    },

    initEndpoints(nodes, newNodes)
    {
        if(this.isReadonly)
            var readonlyClass = "agNode-readonlyEndpoint";

        for(var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];

            var newNode = newNodes.find((newNode) => newNode._id == node.object._id);
            if(newNode)
                continue;

            // no endpoints on satellite nodes
            var satellite = this.store.getters["nodeStore/isSatellite"](node.type);
            if(satellite)
                continue;

            // src (start node does not have src)
            if(node.type != "startNode") {
                var src = {
                    uuid: "src-" + node.object._id,
                    enabled: !this.isReadonly,
                    isSource: false,
                    isTarget: true, 
                    anchor: [0, 0.5, -1, 0, 0, 0],
                    endpoint: ["Rectangle", {cssClass: "agNode-srcEndpoint " + readonlyClass, width: 12.5, height: 12.5}],
                    connector:  ["Flowchart", {
                        cornerRadius: 5,
                        midpoint: 0.5
                    }],
                    connectorOverlays: [["Arrow", {width: 10, length: 10, location: 0.5}]],
                    maxConnections: -1
                }

                this.jsPlumb.addEndpoint(node.object._id, src);
            }


            // dest
            var dest = {
                uuid: "dest-" + node.object._id,
                enabled: !this.isReadonly,
                isSource: true,
                isTarget: false, 
                anchor: [1, 0.5, 1, 0, 0, 0],
                endpoint: ["Rectangle", {cssClass: "agNode-destEndpoint " + readonlyClass, width: 12.5, height: 12.5}],
                connector:  ["Flowchart", {
                    cornerRadius: 5,
                    midpoint: 0.5
                }],
                connectorOverlays: [["Arrow", {width: 10, length: 10, location: 0.5}]],
                maxConnections: 1
            }
            if (node.type == "input") {
                let nDest = 1 + !!_.get(node.object, "dest2.selected") + !!_.get(node.object,"dest3.selected")
                for (var j = 0; j < nDest; j++) {
                    var y = (j * 2 + 1) / (nDest * 2);
                    var label = "";
                    var cIndex = j
                    if(j == 0)
                    {
                        label = "Results"
                        var options = {
                            uuid: "dest" + "-" + node.object._id,
                            anchor: [1, y, 1, 0, 0, 0],
                            connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                            parameters: {
                                objectIndex: j
                            }
                        }
                        this.jsPlumb.addEndpoint(node.object._id, options, dest);
                    }
                    else {
                        if(j == 1 && !!_.get(node.object,"dest2.selected")) {
                            label = "No Results"
                        }
                        else {
                            label = "Error"
                            cIndex = 2
                        }
                        var options = {
                            uuid: "dest" + (cIndex+1).toString() + "-" + node.object._id,
                            anchor: [1, y, 1, 0, 0, 0],
                            connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                            parameters: {
                                objectIndex: cIndex
                            }
                        }
                        this.jsPlumb.addEndpoint(node.object._id, options, dest);
                    }
                }
                
            } else if (node.type == "output") {
                let oDest = 1 + !!_.get(node.object,"dest3.selected")
                for (var j = 0; j < oDest; j++) {
                    var y = (j * 2 + 1) / (oDest * 2);
                    var label = "";
                    var oIndex = j
                    if(j == 0)
                    {
                        label = "Results"
                        var options = {
                            uuid: "dest" + "-" + node.object._id,
                            anchor: [1, y, 1, 0, 0, 0],
                            connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                            parameters: {
                                objectIndex: j
                            }
                        }
                        this.jsPlumb.addEndpoint(node.object._id, options, dest);
                    }
                    else {
                        label = "Error"
                        oIndex = 2
                        
                        var options = {
                            uuid: "dest" + (oIndex+1).toString() + "-" + node.object._id,
                            anchor: [1, y, 1, 0, 0, 0],
                            connectorOverlays: [["Arrow", { width: 10, length: 10, location: 0.4 }], ["Label", { label: label, location: 0.2, labelStyle: { fill: "#FFFFFF" } }]],
                            parameters: {
                                objectIndex: oIndex
                            }
                        }
                        this.jsPlumb.addEndpoint(node.object._id, options, dest);
                    }
                }
            }
            // switches have multiple dests
            else if(node.type == "switch") {

                for(var j = 0; j < node.object.cases.length; j++)
                {
                    var y = (j*2 + 1)/(node.object.cases.length*2);
                    var label = "";
                    if((node.object.cases[j].caseName === undefined || node.object.cases[j].caseName === "" || node.object.cases[j].caseName === null) && j < (node.object.cases.length - 1)){
                        label = "Case " + (j + 1);
                    }else{
                        label = node.object.cases[j].caseName;
                    }
                    if((node.object.cases[j].caseName === undefined || node.object.cases[j].caseName === "" || node.object.cases[j].caseName === null) && j == (node.object.cases.length - 1))
                    {
                        label = "Default";
                    }

                    var options = {
                        uuid: "dest" + j + "-" + node.object._id,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", {width: 10, length: 10, location:0.4}], ["Label", {label: label, location: 0.2, labelStyle: {fill: "#FFFFFF"}}]],
                        parameters: {
                            caseIndex: j
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            else if(node.type == "splitNode") {

                for(var j = 0; j < node.object.paths.length; j++)
                {
                    var y = (j*2 + 1)/(node.object.paths.length*2);
                    var label = "";
                    if((node.object.paths[j].label === undefined || node.object.paths[j].label === "" || node.object.paths[j].label === null)){
                        label = "Path " + (j + 1);
                    }else{
                        label = node.object.paths[j].label;
                    }

                    var options = {
                        uuid: "dest" + j + "-" + node.object._id,
                        anchor: [1, y, 1, 0, 0, 0],
                        connectorOverlays: [["Arrow", {width: 10, length: 10, location:0.4}], ["Label", {label: label, location: 0.2, labelStyle: {fill: "#FFFFFF"}}]],
                        parameters: {
                            pathIndex: j
                        }
                    }
                    this.jsPlumb.addEndpoint(node.object._id, options, dest);
                }
            }
            else {
                this.jsPlumb.addEndpoint(node.object._id, dest);
            }
        }
    },

    initConnections(nodes) {

        // build all connections based on destinations (nodes only have one dest but may have mutliple src)
        for(var i = 0; i < nodes.length; i++)
        {
            var node = nodes[i];
            if(node.type == "switch")
            {
                for(var j = 0; j < node.object.cases.length; j++)
                {
                    var agCase = node.object.cases[j]
                    if(agCase.dest)
                    {
                        var srcUUID = "dest" + j + "-" + node.object._id;
                        var destUUID = "src-" + agCase.dest._id;
                        var result = this.jsPlumb.connect({uuids:[srcUUID, destUUID]});
                    }
                }
            }
            else if(node.type == "splitNode")
            {
                for(var j = 0; j < node.object.paths.length; j++)
                {
                    var agPath = node.object.paths[j]
                    if(agPath.dest)
                    {
                        var srcUUID = "dest" + j + "-" + node.object._id;
                        var destUUID = "src-" + agPath.dest._id;
                        var result = this.jsPlumb.connect({uuids:[srcUUID, destUUID]});
                    }
                }
            }
            if (node.object.dest) {
                var srcUUID = "dest-" + node.object._id;
                if(!!node.object.dest._id){
                    var destUUID = "src-" + node.object.dest._id;
                    var result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                }
            }
            if (node.object.dest2) {
                var srcUUID = "dest2-" + node.object._id;
                if(!!node.object.dest2._id){
                    var destUUID = "src-" + node.object.dest2._id;
                    var result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                }
            }
            if (node.object.dest3) {
                var srcUUID = "dest3-" + node.object._id;
                if(!!node.object.dest3._id){
                    var destUUID = "src-" + node.object.dest3._id;
                    var result = this.jsPlumb.connect({ uuids: [srcUUID, destUUID] });
                }
            }
        }
    },

    initDraggable(nodes) {

        if(this.isReadonly)
            return;

        this.jsPlumb.draggable(nodes, {
            containment: true,
            start: function(e) {
                let node = e.el;
                node.style.zIndex = 2;
            },
            stop: function(e) {
                EventBus.$emit("node_stop", e);
                let node = e.el;
                node.style.zIndex = 1;
            }
        });
        this.jsPlumb.setDraggable(nodes, true);
    },

    validateConnection(srcNode, destNode) {
        return true;
    },
}



// WEBPACK FOOTER //
// ./src/util/jsPlumbUtil.js